// extracted by mini-css-extract-plugin
export default {"button":"Button_button__UzZ5r","none":"Button_none__vM3gK","accent":"Button_accent__V0AUS","red":"Button_red__L+rnC","green":"Button_green__elw7Y"};